import {
  QUERY_PARAM_TRACKER,
  QUERY_PARAM_VALUE_LANDING_PAGE_SEARCH_SECTION_SEARCH_RESULTS,
} from '@src/quince-components/src/molecules/productCard/productCard.helpers'

export const isSearchResult = () => {
  const url = new URL(window.location.href)
  if (
    url.pathname === '/search' ||
    (url.searchParams.has(QUERY_PARAM_TRACKER) &&
      url.searchParams.get(QUERY_PARAM_TRACKER) === QUERY_PARAM_VALUE_LANDING_PAGE_SEARCH_SECTION_SEARCH_RESULTS)
  )
    return true
  return false
}
